import axios from "axios";
import { API_HTTP_CONTEXT } from "constants/api";
import { useAuthStore } from "stores/authStore";

const axiosInstance = axios.create({
  baseURL: API_HTTP_CONTEXT,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token =
    useAuthStore.getState().token ??
    (process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_DEV_TOKEN
      : undefined);

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default axiosInstance;
